//@flow
import React, {Component} from 'react';
import {StyleSheet, View} from 'react-native';
import type {
  NavigationRoute,
  NavigationScreenProp,
} from '@react-navigation/compat';
import {Field} from 'redux-form';
import {Text} from 'trpc-react-native-ui';
import {
  FullButton,
  GradientPage,
  HoshiInput,
  TextArea,
} from '../../../components/common';
import {KeyboardAwareScrollView} from 'react-native-keyboard-aware-scroll-view';
import {PageTitle} from '../../../components/signUp';
import I18n from '../../../lib/i18n';
import pageStyle from '../styles';
import theme from '../../../theme-config';

export default class DeliveryContact extends Component<Props> {
  styles = getStyles();
  phoneNumberInput: any;
  deliveryInstruction: any;

  render() {
    const styles = this.styles;
    const isStandardDelivery =
      this.props.deliveryMethod.id === 'STANDARD_DELIVERY' ||
      this.props.deliveryMethod.type === 'STANDARD';
    return (
      <GradientPage>
        <KeyboardAwareScrollView
          extraHeight={150}
          keyboardShouldPersistTaps="always"
          enableOnAndroid="true">
          <PageTitle
            title={I18n.t('SignUp.DeliveryContact.title')}
            style={pageStyle.title}
          />
          <Text style={styles.subtitle}>
            {isStandardDelivery
              ? I18n.t('SignUp.DeliveryContact.simCardInMailBox')
              : I18n.t(
                  'SignUp.DeliveryContact.simCardInMailBoxUnlessSpecified',
                )}
          </Text>
          <View style={styles.form}>
            <Field
              autoFocus
              name="name"
              component={HoshiInput}
              placeholder={I18n.t('SignUp.DeliveryContact.contactName')}
              returnKeyType="next"
              onSubmitEditing={() =>
                this.phoneNumberInput &&
                this.phoneNumberInput.getRenderedComponent().focus()
              }
              style={styles.input}
              testID={'deliveryContactName'}
            />
            <Field
              forwardRef
              ref={ref => (this.phoneNumberInput = ref)}
              name="phoneNumber"
              component={HoshiInput}
              placeholder={I18n.t('SignUp.DeliveryContact.phoneNumber')}
              returnKeyType={isStandardDelivery ? 'go' : 'next'}
              keyboardType="phone-pad"
              onSubmitEditing={
                isStandardDelivery
                  ? this.props.handleSubmit
                  : () =>
                      this.deliveryInstruction &&
                      this.deliveryInstruction.getRenderedComponent().focus()
              }
              style={styles.input}
            />
            {!isStandardDelivery && (
              <Field
                forwardRef
                ref={ref => (this.deliveryInstruction = ref)}
                name="deliveryInstruction"
                component={TextArea}
                placeholder={I18n.t(
                  'SignUp.DeliveryContact.deliveryInstructions',
                )}
                style={styles.input}
              />
            )}
            <FullButton
              onPress={this.props.handleSubmit}
              text={I18n.t('next')}
              style={styles.button}
            />
          </View>
        </KeyboardAwareScrollView>
      </GradientPage>
    );
  }
}

type Props = {
  navigation: NavigationScreenProp<NavigationRoute>,
  handleSubmit: Function,
  deliveryMethod: Object,
};

function getStyles() {
  return StyleSheet.create({
    subtitle: {
      fontSize: 13,
      color: theme.signUpDarkTextColor,
      textAlign: 'center',
      marginTop: 18,
      marginHorizontal: 16,
    },
    form: {
      marginHorizontal: 20,
      marginTop: 10,
    },
    button: {
      marginVertical: 16,
    },
    input: {
      marginVertical: 8,
    },
  });
}
